import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const serviceDeskServiceListRoute: InvariantJiraRoute = {
	name: 'servicedesk-service-list',
	path: '/jira/ops/services',
	exact: true,
};
